import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import { MenuInfo } from 'rc-menu/lib/interface';
import { ERoutes, ERoutesCommon, ERoutesPrivate, ERoutesPublic } from 'common/models/routesModel';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { logout } from 'app/store/reducers/auth.reducer';

type AllProps = IComponentProps;

interface IComponentProps {
  mode?: 'horizontal' | 'vertical';
  mobile?: boolean;
  close?: () => void;
}

export const HeaderMenu: React.FC<AllProps> = (props) => {
  // ---> Leave as is. Just to update history and path on-the-go
  useAppSelector((state) => state.router);
  // <---
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const { authModel } = useAppSelector((state) => state.auth);
  const { mobile, close } = props;
  const authorized = Boolean(authModel);
  const visibleLogin = Boolean(!authorized && mobile);
  const visibleLogout = Boolean(authorized && mobile);

  const currentPath = pathname?.split(/(^\/[a-zA-Z-]*)/)[1];

  const showLogo = !mobile;
  const mobileClass = mobile ? 'header-menu_mobile' : '';
  const mode = mobile ? 'vertical' : 'horizontal';

  const onLogout = () => {
    if (close) {
      close();
    }

    dispatch(logout());
  };

  const redirect = (e: MenuInfo) => {
    if (close) {
      close();
    }

    navigate(e.key.toString());
  };

  const redirectToMain = () => {
    if (close) {
      close();
    }

    navigate(ERoutesCommon.Root);
  };

  const items: MenuProps['items'] = [
    showLogo ? { key: 'logo', label: <span className="header__title">MB Go!</span>, onClick: redirectToMain } : null,
    { key: ERoutesCommon.Root, label: 'Menu', className: 'header-menu__activilable-item', onClick: redirect },
    authorized
      ? { key: ERoutes.Order, label: 'Current Order', className: 'header-menu__activilable-item', onClick: redirect }
      : null,
    authorized
      ? { key: ERoutes.AccountSettings, label: 'Account settings', className: 'header-menu__activilable-item', onClick: redirect }
      : null,
    authorized
      ? {
          key: ERoutesPrivate.OrderHistory,
          label: 'Order history',
          className: 'header-menu__activilable-item',
          onClick: redirect,
        }
      : null,
    visibleLogin
      ? { key: ERoutesPublic.Login, label: 'Log In', className: 'header-menu__activilable-item mt-8', onClick: redirect }
      : null,
    visibleLogout
      ? { key: 'logout', label: 'Log out', className: 'header-menu__activilable-item mt-8', onClick: onLogout }
      : null,
    { key: ERoutesCommon.Privacy, label: 'Privacy Notice', className: 'header-menu__link-item', onClick: redirect },
    { key: ERoutesCommon.ToS, label: 'Terms of Service', className: 'header-menu__link-item', onClick: redirect },
  ].filter(Boolean) as MenuProps['items'];

  return <Menu selectedKeys={[currentPath]} mode={mode} className={`header-menu ${mobileClass}`} items={items} />;
};
